<template>
  <div>
    <div id="object-help" class="object-action" v-on:click="displayModal($event)">
      <a data-gtm-id="get-help-by-email" href class="btn btn-light">Get help by email</a>
    </div>
    <email-modal v-show="showModal" @close="hideModal"></email-modal>
  </div>
</template>

<script>
  import emailModal from './components/_object-help-email-modal.vue';

  export default {
    components: {
      "email-modal" : emailModal,
    },
    data() {
      return {
        showModal : false
      }
    },
    methods: {
      displayModal(e){
        e.preventDefault();
        this.showModal = true;
      },
      hideModal(){
        this.showModal = false;
      }
    }
  }
</script>
